import { contract_tab, info_tab, versioning_tab } from '../../../../../../views/contract/agreement';

export default {
  title: 'Dettagli contratto',
  tabs: {
    [info_tab]: 'Info',
    [contract_tab]: 'Contratto',
    [versioning_tab]: 'Versionamento',
  },
  sections: {
    price_info: 'Informazioni sul prezzo',
    contact: 'Contratto attuale',
    signature_history: 'Cronologia firme',
  },
  labels: {
    not_signed: 'Il contratto non è ancora stato firmato',
  },
  modals: {
    preview_contract: {
      title: 'Anteprima contratto',
    },
    switch_to_annual: {
      title: 'Passa ad annuale',
    },
  },
  buttons: {
    save: 'Salva',
    preview_and_sign: 'Anteprima e firma',
    download: 'Scarica',
    switch_to_annual: 'Passa ad annuale',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
    failed_to_save_changes: 'Salvataggio modifiche non riuscito',
    changes_got_saved: 'Modifiche salvate',
  },
};
